// eslint-disable-next-line import/no-named-as-default
import Icon from "@mdi/react";

import { mdiDelete } from "@mdi/js";
import { Popconfirm } from "antd";
import styled from "styled-components";

import { Tooltip } from "components/base";

interface OrganizationForecastNodeActionsProps {
  forecastNode;
  onDelete?: (node) => void;
  canEdit?: boolean;
}

export default function OrganizationForecastNodeActions({
  forecastNode,
  onDelete,
  canEdit = true
}: OrganizationForecastNodeActionsProps) {
  const handleDelete = (evt: React.MouseEvent) => {
    evt.stopPropagation();
    evt.preventDefault();
    onDelete?.(forecastNode);
  };

  if (!canEdit) {
    return null;
  }

  return (
    <ForecastActionButtonContainer className="visible-on-hover">
      <Tooltip title="Delete forecast">
        <Popconfirm
          placement="bottom"
          onConfirm={handleDelete}
          onCancel={(evt) => {
            evt?.stopPropagation();
            evt?.preventDefault();
          }}
          okText="Delete"
          okType="danger"
          title={`Are you sure you want to delete this forecast?`}>
          <ForecastActionButton onClick={(event) => event.stopPropagation()}>
            <Icon path={mdiDelete} size={1} />
          </ForecastActionButton>
        </Popconfirm>
      </Tooltip>
    </ForecastActionButtonContainer>
  );
}

// Styled Components
const ForecastActionButtonContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;

  svg {
    opacity: 0;
  }

  .ant-tree-node-content-wrapper:hover &,
  &.visible-always {
    svg {
      opacity: 1;
    }
  }
`;

const ForecastActionButton = styled.button`
  flex: 1 1 auto;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 0;
  padding: 0;
  margin: 3px;
  cursor: pointer;
  background: transparent;
  color: ${(props) => props.color?.toString() ?? "#a2aaad"};

  &:hover {
    color: ${(props) => (props.danger ? "var(--color-danger)" : "var(--color-primary)")};
  }

  &[disabled]:hover > svg {
    cursor: default;
    color: lightgray;
  }
`;
